import { Map } from '@cian/frontend-newbuilding-map-component';
import { RefObject, useEffect } from 'react';

interface IParams {
  routeMapRef: RefObject<Map>;
  mapRef: RefObject<YMaps.Map | undefined>;
  isRouteMapTabActive: boolean;
}

/**
 * Хук реализует идею https://yandex.ru/dev/maps/jsbox/2.1/hiddendiv/, чтобы карта показывалась при показе скрытого контейнера
 */
export const useMapsFitToViewport = ({ routeMapRef, mapRef, isRouteMapTabActive }: IParams) => {
  useEffect(() => {
    if (isRouteMapTabActive && routeMapRef.current) {
      routeMapRef.current.fitToViewport();
    } else if (mapRef.current) {
      mapRef.current.container.fitToViewport();
    }
  }, [isRouteMapTabActive, routeMapRef, mapRef]);
};
